
import {Vue} from "vue-class-component";
import {CabinetSlotRs, SlotsSettingsDto} from "@/types/slots";
import ModuleSlots from "@/store/slots";
import * as ct from "countries-and-timezones";

export default class Slots extends Vue{
    private days: string[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    private loading: boolean = false;
    private allSlotsSettings: SlotsSettingsDto = {
        userId: "",
        timeZone: 0,
        // TODO
        timeZoneId: "(+00:00) Etc/UTC",
        // TODO
        manualScheduleMode: false,
        // TODO
        manualSchedule: new Map(),
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
        exceptions: [],
        createdAt: "",
        updatedAt: ""
    }
    private durations = [
        { duration: 'PT30M', label: '30 min' },
        { duration: 'PT45M', label: '45 min' },
        { duration: 'PT50M', label: '50 min' },
        { duration: 'PT1H', label: '1 hour' },
        { duration: 'PT1H30M', label: '1 hour 30 min' },
        { duration: 'PT2H', label: '2 hour' },
    ];
    private timeZones = Object
        .values(ct.getAllTimezones())
        .map(m => {
            return {
                value: m.utcOffset * 60,
                text: "(" + m.utcOffsetStr + ")" + " " + m.name
            }
        })
        .sort((a, b) => a.value - b.value);

    async mounted() {
        this.allSlotsSettings = await ModuleSlots.getSlotsSettings();
    }

    fetchSlots(day) {
        // Initialize slots for the day if not already done
        if (!this.allSlotsSettings[day]) {
            // this.$set(this.slots, day, []);
            this.allSlotsSettings[day] = [];
        }
    };

    addSlot(day) {
        this.allSlotsSettings[day].push({
            timeStart: '',
            startMenu: true,
            duration: "PT1H"
        });
    };

    confirmRemoveSlot(day, slotIndex) {
        (this[`$dialog`] as any).confirm({title: "Confirm action", text: "Do you want to delete slot", cancelText: "No", confirmationText: "Yes"})
            .then((anwser) => {
                if (anwser) {
                    this.removeSlot(day, slotIndex);
                }
            })
    }

    removeSlot(day, slotIndex) {
        if (this.allSlotsSettings[day][slotIndex]) {
            this.allSlotsSettings[day].splice(slotIndex, 1);
        }
    };

    removeExceptionDay(index) {
        console.log("removeExceptionDay")
        this.allSlotsSettings.exceptions.splice(index, 1);
    }

    async onSubmit() {
        this.loading = true;
        try {
            this.allSlotsSettings = await ModuleSlots.updateSlotsSettings(this.allSlotsSettings);
            const notification = (this[`$notify`] as any).success(
                "Saved successfully"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        catch(error) {
            const notification = (this[`$notify`] as any).error(
                "Failed to save"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        finally {
            this.loading = false;
        }
    }
};
